"use client";

import type { AssistantStaticBubbleVariantProps, UserStaticBubbleVariantProps } from "@ui/components/core/BaseChat";
import {
  assistantBubbleBackgroundVariants,
  assistantBubbleRootVariants,
  TypingDots,
  userBubbleBackgroundVariants,
  userBubbleRootVariants,
} from "@ui/components/core/BaseChat";

export function ChatScenarioAssistantTypingIndicator({
  assistantMessageVariants,
}: {
  assistantMessageVariants: AssistantStaticBubbleVariantProps;
}) {
  return (
    <div role='presentation' aria-hidden className={assistantBubbleRootVariants(assistantMessageVariants)}>
      <div aria-hidden className={assistantBubbleBackgroundVariants(assistantMessageVariants)} />
      <TypingDots />
    </div>
  );
}

export function ChatScenarioUserTypingIndicator({
  userMessageVariants,
}: {
  userMessageVariants: UserStaticBubbleVariantProps;
}) {
  return (
    <div role='presentation' aria-hidden className={userBubbleRootVariants(userMessageVariants)}>
      <div aria-hidden className={userBubbleBackgroundVariants(userMessageVariants)} />
      <TypingDots />
    </div>
  );
}
